var React = require('react');

function List (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1271_433)","key":0},[React.createElement("rect",{"x":"-6.10352e-05","width":"176","height":"25.6007","rx":"12.8003","fill":"black","key":0}),React.createElement("rect",{"x":"-6.10352e-05","y":"46.6006","width":"176","height":"25.6007","rx":"12.8003","fill":"black","key":1}),React.createElement("rect",{"x":"-6.10352e-05","y":"93.2012","width":"176","height":"25.6007","rx":"12.8003","fill":"black","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1271_433"},React.createElement("rect",{"width":"176","height":"119","fill":"white"})))]);
}

List.defaultProps = {"width":"176","height":"119","viewBox":"0 0 176 119","fill":"none"};

module.exports = List;

List.default = List;
